import React, { useEffect, useRef } from "react";
import * as S from "./style";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper";
import "swiper/swiper-bundle.css";
import useWindowSize, { Size } from "hooks/useWindowSize";

interface Props {
  setBannerHeight: (height: number) => void;
  data: Array<{ image: string; url: string }>;
}

const SliderBannerEvent: React.FC<Props> = ({ setBannerHeight, data }) => {
  const settings = {
    modules: [Pagination, Navigation, Autoplay],
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      dynamicBullets: true,
    },
    autoplay: { delay: 5000, disableOnInteraction: false },
    centeredSlides: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };

  const mobileSettings = {
    modules: [Pagination, Autoplay],
    pagination: { clickable: true },
    autoplay: { delay: 5000, disableOnInteraction: false },
    centeredSlides: true,
    autoHeight: true,
  };

  const size: Size = useWindowSize();
  const isMobile = size.width && size.width <= 767;
  const isTab = size.width && size.width >= 768 && size.width <= 1024;
  const bannerImgRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (bannerImgRef.current) {
      setBannerHeight(bannerImgRef.current.clientHeight);
    }
  });

  return (
    <div>
      <S.Container className="main-slider">
        <Swiper
          {...(isMobile ? mobileSettings : settings)}
          onSwiper={(swiper) => setBannerHeight(swiper.el.clientHeight)}
        >
          {data?.map((item, index) =>
            item.url ? (
              <SwiperSlide key={index}>
                <a href={item.url}>
                  <img src={item.image} alt={`banner_${index}`} />
                </a>
              </SwiperSlide>
            ) : (
              <SwiperSlide key={index}>
                <img src={item.image} alt={`banner_${index}`} />
              </SwiperSlide>
            )
          )}
          <div className="swiper-pagination"></div>
          {!isMobile && !isTab && (
            <div className="swiper-button">
              <div className="swiper-button-next"></div>
              <div className="swiper-button-prev"></div>
            </div>
          )}
        </Swiper>
      </S.Container>
    </div>
  );
};

export default SliderBannerEvent;
